export const FIND_PSEUDONYM_FAILURE = 'FIND_PSEUDONYM_FAILURE';

export const findPseudonymFailure = error => ({
    type: FIND_PSEUDONYM_FAILURE,
    payload: error,
    error: true,
});
